export const STRATEGIES = [
  {
    id: 'lanzamiento',
    name: 'Lanzamiento en Directo',
    icon: 'Radio',
    color: '#EF4444',
    description: 'Webinars y eventos en vivo con carrito limitado',
    variants: [
      { id: '1-directo', name: '1 Solo Directo', description: 'Webinar + 24h carrito' },
      { id: '2-directos', name: '2 Directos', description: 'Apertura + cierre' },
      { id: '3-directos', name: '3 Directos', description: 'Formación + pitch + cierre' },
      { id: 'serie-lives', name: 'Serie de Lives', description: 'Con Replay disponible' },
    ],
  },
  {
    id: 'evergreen',
    name: 'Evergreen Automatizado',
    icon: 'Leaf',
    color: '#22C55E',
    description: 'Funnels automatizados que venden 24/7',
    variants: [
      { id: 'vsl', name: 'VSL Funnel', description: 'Video Sales Letter' },
      { id: 'quiz', name: 'Quiz Funnel', description: 'Segmentación por cuestionario' },
      { id: 'webinar-evergreen', name: 'Webinar Evergreen', description: 'Simulado automático' },
      { id: 'email-only', name: 'Email-Only Funnel', description: 'Secuencia de emails' },
      { id: 'tripwire', name: 'Tripwire', description: 'Oferta bajo coste → upsell' },
      { id: 'slo', name: 'Self-Liquidating Offer', description: 'Recuperar coste de ads' },
      { id: 'micro-continuidad', name: 'Micro-Continuidad', description: 'Suscripción de bajo ticket' },
      { id: 'bridge', name: 'Bridge Funnel', description: 'Puente hacia la oferta' },
    ],
  },
  {
    id: 'plf',
    name: 'PLF — Product Launch Formula',
    icon: 'Package',
    color: '#F59E0B',
    description: 'Lanzamiento con secuencia de contenido',
    variants: [
      { id: 'plf-clasico', name: 'PLF Clásico', description: '4 vídeos + Open Cart 7 días' },
      { id: 'plf-bonos', name: 'PLF con Bonos', description: 'Bonos por acción temprana' },
    ],
  },
  {
    id: 'ecommerce',
    name: 'Ecommerce',
    icon: 'ShoppingCart',
    color: '#EC4899',
    description: 'Estrategias para tiendas online',
    variants: [
      { id: 'lead-magnet-nurture', name: 'Lead Magnet + Nurture', description: 'Captación y nutrición' },
      { id: 'flash-sale', name: 'Flash Sale', description: 'Oferta relámpago' },
      { id: 'abandono-carrito', name: 'Abandono de Carrito', description: 'Recuperación de ventas' },
      { id: 'post-compra', name: 'Post-compra', description: 'Upsell/Cross-sell' },
      { id: 'temporada', name: 'Temporada / Black Friday', description: 'Campañas estacionales' },
    ],
  },
  {
    id: 'high-ticket',
    name: 'High Ticket / Consultoría',
    icon: 'Phone',
    color: '#8B5CF6',
    description: 'Ventas de alto valor con llamada',
    variants: [
      { id: 'aplicacion-llamada', name: 'Aplicación + Llamada', description: 'Proceso de calificación' },
      { id: 'challenge-llamada', name: 'Challenge 5 días + Llamada', description: 'Desafío + cierre' },
      { id: 'vsl-llamada', name: 'VSL + Llamada', description: 'Video + agendamiento' },
    ],
  },
  {
    id: 'challenge',
    name: 'Desafío (Challenge Funnel)',
    icon: 'Trophy',
    color: '#F97316',
    description: 'Desafíos de varios días',
    variants: [
      { id: 'challenge-5', name: 'Desafío 5 días', description: 'Transformación rápida' },
      { id: 'challenge-7', name: 'Desafío 7 días', description: 'Una semana de cambio' },
      { id: 'challenge-30', name: 'Desafío 30 días', description: 'Transformación completa' },
    ],
  },
  {
    id: 'membresia',
    name: 'Membresía / Comunidad',
    icon: 'Gem',
    color: '#06B6D4',
    description: 'Suscripciones y comunidades',
    variants: [
      { id: 'trial-pago', name: 'Prueba Gratuita → Pago', description: 'Trial con conversión' },
      { id: 'descuento-inaugural', name: 'Descuento Inaugural', description: 'Acceso directo con oferta' },
      { id: 'waitlist', name: 'Waitlist + Apertura', description: 'Lista de espera exclusiva' },
    ],
  },
  {
    id: 'saas',
    name: 'SaaS',
    icon: 'Laptop',
    color: '#3B82F6',
    description: 'Software como servicio',
    variants: [
      { id: 'free-trial', name: 'Free Trial 14 días', description: 'Prueba gratuita' },
      { id: 'freemium', name: 'Freemium → Upgrade', description: 'Plan gratis con mejoras' },
      { id: 'demo-onboarding', name: 'Demo + Onboarding', description: 'Demostración guiada' },
    ],
  },
  {
    id: 'contenido',
    name: 'Estrategia de Contenido Orgánico',
    icon: 'Target',
    color: '#10B981',
    description: 'Monetización de contenido',
    variants: [
      { id: 'lead-magnet-auto', name: 'Lead Magnet + Automatización', description: 'Captación orgánica' },
      { id: 'viral-captura', name: 'Contenido Viral + Captura', description: 'Viralidad estratégica' },
      { id: 'newsletter', name: 'Newsletter Monetizada', description: 'Email de valor' },
    ],
  },
];

export const TONES = [
  { id: 'inspiracional', name: 'Inspiracional', description: 'Motivador y aspiracional' },
  { id: 'directo', name: 'Directo', description: 'Al grano, sin rodeos' },
  { id: 'educativo', name: 'Educativo', description: 'Informativo y formativo' },
  { id: 'urgente', name: 'Urgente', description: 'Escasez y acción inmediata' },
  { id: 'cercano', name: 'Cercano', description: 'Amigable y personal' },
];

export const VISUAL_STYLES = [
  { id: 'minimalista', name: 'Minimalista' },
  { id: 'impactante', name: 'Impactante' },
  { id: 'profesional', name: 'Profesional' },
  { id: 'creativo', name: 'Creativo' },
  { id: 'lujo', name: 'Lujo' },
];

export const TYPOGRAPHY_STYLES = [
  { id: 'moderna', name: 'Moderna' },
  { id: 'clasica', name: 'Clásica' },
  { id: 'bold', name: 'Bold' },
  { id: 'elegante', name: 'Elegante' },
  { id: 'tecnica', name: 'Técnica' },
];

export const WIZARD_STEPS = [
  { id: 1, name: 'Estrategia', description: 'Selecciona tu tipo de funnel' },
  { id: 2, name: 'Brief', description: 'Define tu proyecto' },
  { id: 3, name: 'Editor de Landings', description: 'Diseño y estructura' },
  { id: 4, name: 'Secuencias', description: 'Emails y WhatsApp' },
  { id: 5, name: 'Creativos', description: 'Copy y creativos publicitarios' },
  { id: 6, name: 'Integración', description: 'GHL y plataformas' },
  { id: 7, name: 'Campañas', description: 'Lanzamiento de ads' },
  { id: 8, name: 'Dashboard', description: 'Vista general' },
];

export const getStrategyById = (id) => STRATEGIES.find(s => s.id === id);
export const getVariantById = (strategyId, variantId) => {
  const strategy = getStrategyById(strategyId);
  return strategy?.variants.find(v => v.id === variantId);
};
